export const roles = {
  ROLE_ADMIN: {
    path: '/operation-map',
  },
  ROLE_HOST: {
    path: '/host-invoices',
  },
  ROLE_SUPPORT: {
    path: '/map',
  },
  ROLE_HAUSEFUL_FINANCIAL: {
    path: '/admin-movements',
  },
  ROLE_REAL_ESTATE: {
    path: '/board',
  },
  ROLE_COMPANY: {
    path: '/board',
  },
  ROLE_HAUSEFUL_OPERATOR: {
    path: '/map',
  },
  ROLE_PEOPLE: {
    path: '/admin-appointment',
  },
  ROLE_REAL_ESTATE_OPERATOR: {
    path: '/operator',
  },
  ROLE_REAL_ESTATE_FINANCIAL: {
    path: '/real-estate-financial',
  },
  ROLE_PEOPLE: {
    path: '/people'
  },
  ROLE_PARTNER: {
    path: '/partner-map'
  },
  ROLE_SERVICE_PROVIDER: {
    path: '/board',
  },
}

export const onboardingRoles = {
  COMPLETE: {
    path: '/board',
  },
  NO_CREDIT: {
    path: '/onboarding/steps',
  },
  NO_CITY: {
    path: '/onboarding/steps',
  },
  NO_SUBSCRIPTION: {
    path: '/onboarding/steps',
  },
  NO_SERVICE: {
    path: '/board',
  },
  undefined: {
    path: '/board',
  },
  null: {
    path: '/board',
  },
}
